export default class AdminToolbar extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-admin-toolbar', AdminToolbar);
